"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { AdSlot } from "@/features/ads/AdSlot";
import { RelatedEntities } from "@/views/post/partials/RelatedEntities/RelatedEntities";
import { TabbedPosts } from "@/views/post/partials/TabbedPosts/TabbedPosts";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";

/**
 * SidebarContent for the DefaultWithSidebar video variant.
 * Contains:
 * 1. Banner placeholder
 * 2. Related entities (teams, players, competitions) - 1 per row
 * 3. Tabbed related content (related videos + latest from category) with minimal cards
 */
export function SidebarContent() {
  const $ = _c(12);
  const labels = useLabels();
  const nav = useNavigation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AdSlot id="sidebar-top" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = (labels as any).videoPage?.about;
  let t2;
  if ($[1] !== t1) {
    t2 = <RelatedEntities variant="compact" columns={1} className="" aboutLabel={t1} />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = (labels as any).videoPage?.relatedVideos;
  const t4 = (labels as any).videoPage?.latestFromCategory;
  const t5 = (labels as any).videoPage?.latestNews;
  let t6;
  if ($[3] !== nav.post || $[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = <TabbedPosts variant="default" columns={1} className="" buildLink={nav.post} relatedLabel={t3} categoryLabel={t4} latestLabel={t5} />;
    $[3] = nav.post;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AdSlot id="sidebar-bottom" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t2 || $[10] !== t6) {
    t8 = <aside className="w-full lg:min-w-75 lg:w-75 shrink-0"><div className="sticky top-below-nav-gap space-y-6">{t0}{t2}{t6}{t7}</div></aside>;
    $[9] = t2;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}